import { useQuery } from '@tanstack/react-query';
import dashboardApi from '@/api/dashboardApi';

export const DASHBOARD_QUERY_KEY = ['dashboard', 'my-items'];

export function useDashboard() {
  return useQuery({
    queryKey: DASHBOARD_QUERY_KEY,
    queryFn: dashboardApi.getMyItems,
  });
}
